import { useProject } from '../../hooks/useProject';
import { useResourceOne } from '../../hooks/useResourceOne';
import { useTaskFeedback } from '../../hooks/useTaskFeedback';
import { useSimpleTask } from '../../hooks/useSimpleTask';
import { DialogUI } from '../Interface';

const AddDialog = ({ addDialogData, handleClose, changed, SpecificComponent, getViewField }) => {
  const { taskChanged, setTaskChanged } = changed;
  const projectState = useProject();
  const resourceOneState = useResourceOne();
  const taskFeedbackState = useTaskFeedback();
  const simpleTaskState = useSimpleTask();

  return (
    <DialogUI
      open={addDialogData.open}
      onClose={SpecificComponent && !getViewField(addDialogData?.overrideType) ? () => {} : handleClose}
      headerContent="Új felvitel"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '1500px',
          },
        },
      }}
    >
      <div className="mt-5">
        {addDialogData.open && SpecificComponent && (
          <div className="-mt-5">
            <SpecificComponent
              projectState={projectState}
              resourceOneState={resourceOneState}
              taskFeedbackState={taskFeedbackState}
              simpleTaskState={simpleTaskState}
              dialog={{
                handleClose: handleClose,
                taskChanged: taskChanged,
                setTaskChanged: setTaskChanged,
                dialogData: addDialogData.dialogData,
              }}
            />
          </div>
        )}
      </div>
    </DialogUI>
  );
};

export default AddDialog;
